module.exports = __webpack_public_path__ + "img/battery-icon.320bbdc1.png";